// extracted by mini-css-extract-plugin
export default {"GroupContainer":"styles_GroupContainer__njDCg","DetailsModal":"styles_DetailsModal__K9p-j","RemoveModal":"styles_RemoveModal__DHLnr"};